'use strict';
import appConstants from 'constants/appConstants';

const SIGN_UP_WINDOW_MS = 60 * 60 * 1000;

const storageUtils = {
    getUserIdPFromStorage: () => {
        return storageUtils.getValueFromStorage(appConstants.STORAGE.USER_IDP);
    },

    setUserIdPToStorage: (value) => {
        storageUtils.setValueToStorage(appConstants.STORAGE.USER_IDP, value);
    },

    getUserFromStorage: () => {
        return storageUtils.getValueFromStorage(appConstants.STORAGE.USER);
    },

    setUserToStorage: (value) => {
        storageUtils.setValueToStorage(appConstants.STORAGE.USER, value);
    },

    isSignUpInProgress: () => {
        const startedAt = JSON.parse(sessionStorage.getItem(appConstants.STORAGE.SIGN_UP_IN_PROGRESS) || 'null');
        return typeof startedAt === 'number' && (Date.now() - startedAt) < SIGN_UP_WINDOW_MS;
    },

    setSignUpInProgress: () => {
        sessionStorage.setItem(appConstants.STORAGE.SIGN_UP_IN_PROGRESS, JSON.stringify(Date.now()));
    },

    clearSignUpInProgress: () => {
        sessionStorage.removeItem(appConstants.STORAGE.SIGN_UP_IN_PROGRESS);
    },

    broadcastSignOut: () => {
        localStorage.setItem(appConstants.STORAGE.SIGNED_OUT, JSON.stringify(Date.now()));
        localStorage.removeItem(appConstants.STORAGE.SIGNED_OUT);
    },

    isSignOutBroadcast: (event) => {
        return event.key === appConstants.STORAGE.SIGNED_OUT && !!event.newValue;
    },

    getValueFromStorage: (key) => {
        switch (appConstants.auth.OIDC_CACHE_LOCATION) {
            case 'localStorage':
                return JSON.parse(localStorage.getItem(key) || 'null');
            case 'sessionStorage':
                return JSON.parse(sessionStorage.getItem(key) || 'null');
            default:
                return JSON.parse(sessionStorage.getItem(key) || 'null');
        }
    },

    setValueToStorage: (key, value) => {
        switch (appConstants.auth.OIDC_CACHE_LOCATION) {
            case 'localStorage':
                localStorage.setItem(key, JSON.stringify(value));
                break;
            case 'sessionStorage':
            default:
                sessionStorage.setItem(key, JSON.stringify(value));
                break;
        }        
    },  
  
    removeValueFromStorage: (key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
    },

    clearStorage: () => {
        localStorage.clear();
        sessionStorage.clear();
    },
};

export default storageUtils;